import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es6.number.constructor.js";
import React from 'react';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Box } from '../Box/Box';
import { Stars } from './Stars';
import styles from './StarRating.module.less';
export var RATING_LABELS = {
  1: 'Hate it',
  2: 'Dislike it',
  3: 'It’s OK',
  4: 'Like it',
  5: 'Love it'
};
export var StarRatingInput = function StarRatingInput(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      id = _ref.id,
      label = _ref.label,
      _ref$maxRating = _ref.maxRating,
      maxRating = _ref$maxRating === void 0 ? 5 : _ref$maxRating,
      nerdwallet = _ref.nerdwallet,
      onChange = _ref.onChange,
      _ref$rating = _ref.rating,
      ratingProp = _ref$rating === void 0 ? 0 : _ref$rating,
      _ref$ratingLabels = _ref.ratingLabels,
      ratingLabels = _ref$ratingLabels === void 0 ? RATING_LABELS : _ref$ratingLabels;

  var _React$useState = React.useState(ratingProp !== null && ratingProp !== void 0 ? ratingProp : 0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      rating = _React$useState2[0],
      setRating = _React$useState2[1];

  var prevRatingProp = React.useRef(ratingProp);
  useDeprecatedClassNameStylePropsWarning('StarRatingInput', {
    className: className
  }); // Allow rating to be controlled by the prop

  React.useEffect(function () {
    if (ratingProp !== prevRatingProp.current) {
      setRating(ratingProp);
      prevRatingProp.current = ratingProp;
    }
  }, [ratingProp]);
  var handleClick = React.useCallback(function (e) {
    var value = e.target.value;
    var currentRating = rating;
    var eventRating = Number(value); // if rating is the same, unset

    var newRating = currentRating === eventRating ? 0 : eventRating;
    setRating(newRating);
    onChange === null || onChange === void 0 ? void 0 : onChange(newRating);
  }, [rating, onChange]);
  var PROMPT = 'Select your rating';
  var FIELDSET_ID = id && "".concat(id, "__fieldset");
  var LEGEND_ID = id && "".concat(id, "__legend");
  var OUTPUT_ID = id && "".concat(id, "__output");
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    userSelect: "none",
    className: [styles.container, className]
  }, /*#__PURE__*/React.createElement(Box, {
    component: "fieldset",
    display: "inline-block",
    border: "0",
    className: styles["star-".concat(rating, "-clicked")],
    disabled: disabled,
    "aria-labelledby": label && LEGEND_ID,
    "aria-label": !label ? PROMPT : undefined,
    "aria-describedby": OUTPUT_ID
  }, label && /*#__PURE__*/React.createElement("span", {
    id: LEGEND_ID,
    className: styles.legend
  }, label), /*#__PURE__*/React.createElement(Stars, {
    id: id,
    error: error,
    maxRating: maxRating,
    nerdwallet: nerdwallet,
    onClick: handleClick,
    rating: rating
  })), ratingLabels && /*#__PURE__*/React.createElement("output", {
    id: OUTPUT_ID,
    htmlFor: FIELDSET_ID,
    className: styles.output
  }, ratingLabels[rating] || PROMPT));
};
StarRatingInput.displayName = 'StarRatingInput';